module.exports = __webpack_public_path__ + "static/media/gen_abs_ex1.fd3bc4f1.JPG";